/**
 * Utilitaires pour la navigation du formulaire référent
 */

export const stepTitles = [
  "Informations contextuelles",
  "Signature",
  "Période de collaboration", 
  "Évaluation candidat",
  "Questions critiques",
  "Enregistrement audio obligatoire",
  "Confirmation"
];

// Hook pour gérer la logique de navigation
export const useReferentFormNavigation = (
  currentStep: number,
  totalSteps: number,
  formData: any,
  setCurrentStep: (step: number) => void
) => {
  const canGoPrevious = currentStep > 1;
  const canGoNext = validateCurrentStep(currentStep, formData);
  const isLastStep = currentStep === totalSteps;

  const handleNext = () => {
    if (canGoNext && !isLastStep) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (canGoPrevious) {
      setCurrentStep(currentStep - 1);
    }
  };

  return {
    canGoNext,
    canGoPrevious,
    isLastStep,
    handleNext,
    handlePrevious
  };
};

// Fonction pour valider l'étape courante
export const validateCurrentStep = (currentStep: number, formData: any): boolean => {
  switch (currentStep) {
    case 1: // Informations contextuelles
      return !!(formData.relationTypeConfirmed);
    
    case 2: // Signature
      return !!(formData.signedDocumentUrl);
    
    case 3: // Période de collaboration
      return !!(formData.collaborationStartDate);
    
    case 4: // Évaluation candidat
      return formData.ratings && Object.keys(formData.ratings).length > 0;
    
    case 5: // Questions critiques
      return formData.criticalQuestions && 
             formData.criticalQuestions.wouldRecommend !== null &&
             formData.criticalQuestions.wouldRehire !== null &&
             formData.criticalQuestions.hasIncidents !== null &&
             // Si hasIncidents est true, la description est obligatoire
             (formData.criticalQuestions.hasIncidents === false || 
              (formData.criticalQuestions.hasIncidents === true && 
               formData.criticalQuestions.incidentsDescription?.trim()));
    
    case 6: // Enregistrement audio (obligatoire)
      return !!(formData.audioFileUrl || formData.audioTranscription);
    
    case 7: // Confirmation
      return true; // Dernière étape, toujours valide
    
    default:
      return false;
  }
};